import React from 'react';

const LoadingOverlay = () => {
  return (
    <div className="absolute inset-0 bg-ui-light-background dark:bg-ui-dark-background flex items-center justify-center">
      <div className="p-8 bg-ui-light-card dark:bg-ui-dark-card rounded-lg shadow-md transition-colors">
        <div className="flex flex-col items-center justify-center space-y-4">
          <div className="relative">
            <div className="w-12 h-12 border-4 border-primary-200 dark:border-primary-800 rounded-full"></div>
            <div className="absolute top-0 left-0 w-12 h-12 border-4 border-transparent border-t-primary-600 dark:border-t-primary-400 rounded-full animate-spin"></div>
          </div>
          <div className="text-center">
            <p className="text-lg font-medium text-ui-light-text-primary dark:text-ui-dark-text-primary">
              Loading Sky Atlas
            </p>
            <p className="text-sm text-ui-light-text-tertiary dark:text-ui-dark-text-tertiary mt-1">
              Initializing Aladin Lite...
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;